import { isEmpty } from 'lodash';
import { formatWarehouseMappingIfNeeded } from '../components/modals/AccountIdConfigModal/Form/helpers/dynamicTableUpdateStateHelper';
import {
  AUTO_GENERATE_ACCOUNT_ID,
  DIRECT_DIVISION_CODE_MAPPING,
  DYNAMIC_ACCOUNT_ID,
  OPTIONAL_SECOND_ACCOUNT_ID,
  SECOND_ACCOUNT_ID,
} from '../store/constants/accountIdConfigTypes';
import { hasIntersection } from '../utils/array';
import { humanize } from '../utils/humanize';
import { SHOPIFY_INTEGRATION_TYPE } from '../constants/integrationTypes';

export function getOptionsForDynamicWarehouseTable(props) {
  try {
    return props.warehouses.map((warehouse) => {
      const accountIdTypes = getAccountIdTypeOptionsPerWarehouse(props.accountIdTypes, warehouse);
      return {
        ...warehouse,
        accountIdTypes,
        warehouseId: warehouse.id,
        get secondAccountIdConfig() {
          return getSecondAccountIdConfigForSupplierRetailer(props.accountIdTypes);
        },
        selectedAccountIdType: accountIdTypes[0],
      };
    });
  } catch (error) {
    console.warn('Error initializing options for dynamic warehouse table', error);
    return [];
  }
}

export function getSecondAccountIdConfigForSupplierRetailer(accountIdTypes) {
  const supportedAccountIdOptions = [...new Set(Object.values(accountIdTypes).flat())];
  return {
    shouldShowSecondAccountIdInput: hasIntersection(supportedAccountIdOptions, [
      OPTIONAL_SECOND_ACCOUNT_ID,
      SECOND_ACCOUNT_ID,
    ]),
    isOptional:
      supportedAccountIdOptions.includes(OPTIONAL_SECOND_ACCOUNT_ID) &&
      !supportedAccountIdOptions.includes(SECOND_ACCOUNT_ID),
  };
}

export function getStaticInputTooltip(secondAccountIdConfig) {
  const header = 'This is a static account id that will be applied to all your warehouses';
  if (secondAccountIdConfig.shouldShowSecondAccountIdInput && !secondAccountIdConfig.isOptional) {
    return {
      header,
      subHeader: 'One or more warehouse integrations requires two mandatory account ids.',
    };
  }
  return {
    header,
  };
}

export const shouldDisableSelectDropdown = (accountIdTypes = []) => accountIdTypes.length <= 1;

export const getAutoGeneratedAccountIdValue = (option, accountIdConfig) => {
  if (isEmpty(accountIdConfig?.autoGenerateMapping)) return false;
  try {
    const accountIdConfigMapping = formatWarehouseMappingIfNeeded(accountIdConfig.mapping);
    const configFromOption = accountIdConfigMapping[option.warehouseId];
    if (configFromOption?.type !== AUTO_GENERATE_ACCOUNT_ID) return false;

    return accountIdConfig.autoGenerateMapping[option.warehouseId];
  } catch (error) {
    return false;
  }
};

function getAccountIdTypeOptionsPerWarehouse(accountIdTypes, warehouse) {
  const accountIdTypesForWarehouse = (accountIdTypes?.[warehouse.id] || ['static']).filter(
    (type) => type !== DYNAMIC_ACCOUNT_ID,
  );

  const isShopifyWarehouse = warehouse.orders_integration_type === SHOPIFY_INTEGRATION_TYPE;

  const labelMappingForType = {
    [SECOND_ACCOUNT_ID]: 'Mandatory two account ids',
    [OPTIONAL_SECOND_ACCOUNT_ID]: 'Optional two account ids',
    [AUTO_GENERATE_ACCOUNT_ID]: `Generate account id ${isShopifyWarehouse ? 'from Shopify' : ''}`,
    [DIRECT_DIVISION_CODE_MAPPING]: 'Use retailer division code',
  };
  return accountIdTypesForWarehouse.map((type) => ({
    label: labelMappingForType[type] ?? humanize(type),
    value: type,
  }));
}
